export default __webpack_public_path__ + "static/media/404 error page.d7d87954.png";